export default "__VITE_ASSET__D9a4DUgK__"